export enum Backgrounds
{
    One = '/images/sales/background-overlay.jpg',
    Two = '/images/sales/background-overlay-2.jpg',
    Three = '/images/sales/background-overlay-3.jpg',
    Four = '/images/sales/background-overlay-4.jpg',
    Five = '/images/sales/background-overlay-5.jpg'
}